/**
 * "Remember this device" for the second factor.
 *
 * How long a browser that has entered a valid code may skip the code on later
 * sign-ins. Thirty days is the figure most services settle on: long enough
 * that a daily user is asked roughly once a month, short enough that a laptop
 * left in a drawer is not trusted indefinitely.
 *
 * Shared so the sign-in screen states the same number the server enforces.
 */
export const TRUSTED_DEVICE_DAYS = 30;
